module.exports = ".navbar-login {\n  width: 305px;\n  padding: 10px;\n  padding-bottom: 0px; }\n\n.navbar-login-session {\n  padding: 10px;\n  padding-bottom: 0px;\n  padding-top: 0px; }\n\n.icon-size {\n  font-size: 87px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/cart/cart.component.scss
// module id = ./src/app/cart/cart.component.scss
// module chunks = main